"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardWithHeader = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("../../../utils");
var p = utils_1.createPrefixer("wh-Layouts-CardWithHeader-");
var classes = {
    header: p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["header"], ["header"]))),
    contentWrapper: p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["contentWrapper"], ["contentWrapper"]))),
    content: p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["content"], ["content"]))),
};
var Wrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &&& {\n    height: auto;\n    .", " {\n      background-color: #111d2c;\n      color: white;\n      padding: 1rem;\n      font-weight: 600;\n    }\n\n    .", " {\n      background-color: white;\n    }\n  }\n"], ["\n  &&& {\n    height: auto;\n    .", " {\n      background-color: #111d2c;\n      color: white;\n      padding: 1rem;\n      font-weight: 600;\n    }\n\n    .", " {\n      background-color: white;\n    }\n  }\n"])), classes.header, classes.contentWrapper);
var CardWithHeader = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.loading, loading = _b === void 0 ? false : _b, style = _a.style;
    return (react_1.default.createElement(Wrapper, { style: style, className: "wh-vertical-scroller-container" },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: classes.header }, loading ? (react_1.default.createElement(antd_1.Skeleton, { paragraph: false, active: true, title: { style: { margin: 0, background: "#bebebe33" } } })) : (title))),
        react_1.default.createElement("div", { className: classnames_1.default(classes.contentWrapper, "wh-vertical-scroller-container-scroll") },
            react_1.default.createElement("div", { className: classes.content }, children))));
};
exports.CardWithHeader = CardWithHeader;
CardWithHeader.classes = classes;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
